import React from "react";
import { Box } from "@mui/material";
import {
  StyledSelectChannelItemContainer,
  StyledSelectChannelItemTitle,
} from "./SelectChannelItem.styles";
import { Checkbox } from "@metacrm/metacrm-material-ui/dist/Checkbox";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import PropTypes from "prop-types";
import { formatNumberWithComma } from "features/helpers/utils";
import SidebarLoadingIcon from "components/LoadingComponent/SidebarLoadingIcon";

const SelectChannelItem = ({
  channelDataInfo,
  onChange,
  loading,
  readOnly,
}) => {
  const {
    title,
    errors,
    disabled,
    selected,
    iconContent,
    estimatedReachContent,
    id,
  } = channelDataInfo;
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const renderEstimatedReachContent = () => {
    if (loading) {
      if (id === "widget") {
        return (
          <Box display={"flex"} ml="8px">
            -
          </Box>
        );
      } else {
        return (
          <Box display={"flex"} ml="8px">
            <SidebarLoadingIcon />
          </Box>
        );
      }
    } else {
      return (
        <Box
          sx={{
            fontSize: "12px",
            color: theme.customColors.purple[500],
            lineHeight: "1px",
            marginLeft: "5px",
            fontWeight: 700,
          }}
        >
          {estimatedReachContent ? estimatedReachContent : "-"}
        </Box>
      );
    }
  };

  return (
    <StyledSelectChannelItemContainer
      errors={errors}
      selected={selected}
      disabled={disabled}
      readOnly={readOnly}
    >
      {!readOnly && (
        <Checkbox
          checked={selected}
          onChange={onChange}
          name={id}
          disabled={disabled}
          mr={8}
        ></Checkbox>
      )}

      <StyledSelectChannelItemTitle
        errors={errors}
        selected={selected}
        disabled={disabled}
        readOnly={readOnly}
      >
        {title}
      </StyledSelectChannelItemTitle>
      <Box>{iconContent}</Box>
      <Box
        ml="auto"
        minWidth={readOnly ? "none" : "200px"}
        display={"flex"}
        alignItems={"center"}
      >
        <Box sx={{ color: theme.customColors.grey[700] }}>
          {formatMessage({ id: "notification.create.estimatedReach" })} :
        </Box>
        {renderEstimatedReachContent()}
      </Box>
    </StyledSelectChannelItemContainer>
  );
};

SelectChannelItem.propTypes = {
  channelDataInfo: PropTypes.shape({
    title: PropTypes.string,
    errors: PropTypes.bool,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    iconContent: PropTypes.node,
    estimatedReachContent: PropTypes.node,
  }),
  onChange: PropTypes.func,
};

SelectChannelItem.defaultProps = {
  channelDataInfo: {
    title: "",
    errors: false,
    disabled: false,
    selected: false,
    iconContent: null,
    estimatedReachContent: null,
  },
  onChange: () => {},
};

export default SelectChannelItem;
